import InputEssay from "./InputEssay";
import InputJenisSoal from "./InputJenisSoal";
import InputMultiple from "./InputMultiple";
import InputPilgan from "./InputPilgan";
import InputPoint from "./InputPoint";
import InputWaktuSoal from "./InputWaktuSoal";
import SelectMultiple from "./SelectMultiple";
import SelectKolaborasi from "./SelectKolaborasi";
import FormDiskusi from "./FormDiskusi";
import InputEditor from "./InputEditor";
import InputTextEditor from "./InputTextEditor";
import InputFileSoal from "./InputFileSoal";
import InputFileSoalCerita from "./InputFileSoalCerita";
export {
  SelectMultiple,
  InputPilgan,
  InputMultiple,
  InputEssay,
  InputPoint,
  InputWaktuSoal,
  InputJenisSoal,
  SelectKolaborasi,
  InputTextEditor,
  FormDiskusi,
  InputEditor,
  InputFileSoal,
  InputFileSoalCerita,
};
